<mat-card
    class="publication"
    appearance="outlined"
    (click)="onPublicationOpen()"
>
    <button
        type="button"
        class="cloning-button"
        mat-icon-button
        [matMenuTriggerFor]="menu"
        (click)="$event.stopPropagation()"
        #menuTrigger="matMenuTrigger"
        [class.cloning-button--active]="menuTrigger.menuOpen"
    >
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <button
            mat-menu-item
            (click)="onClone()"
        >
            <mat-icon>content_copy</mat-icon>
            <span>Sklonuj publikację</span>
        </button>
    </mat-menu>
    <mat-card-header class="publication-card__header">
        <mat-card-title>{{ publication?.name }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="publication-card__content">
        <p>{{ publication?.description }}</p>
    </mat-card-content>
    <mat-card-footer class="publication-card__footer">
        <mat-chip-set aria-label="Publication parameters">
            @for (param of publication?.params; track param.id) {
                <mat-chip>{{ param.symbol }}</mat-chip>
            }
        </mat-chip-set>
    </mat-card-footer>
</mat-card>
